import axios from 'axios';

const STORE_URL = 'https://happyboxstore.com';
const COLLECTION_HANDLE = 'build-a-happy-box';
const MAIN_PRODUCT_TYPE = 'Box';
const ADDON_PRODUCT_TYPE = 'Gift';
const CARD_PRODUCT_TYPE = 'Card';

const actions = {
  getCart(context) {
    axios.get(`${STORE_URL}/cart.js`)
    .then(response => response.data)
    .then((data) => {
      context.commit('setCurrentCart', data);
      let items = data.items.filter(x => !x.properties["Added to"] && x.product_type != "Box" && x.product_type != "Card" && x.product_type != "Gift Collection" && x.id != 39251483197605);
      if(items.length == 0){
        location.href = "/"
      }
    })
  },
  getFeeProduct(context) {
    axios.get(`/products/handpacking-fee-5.js`)
    .then(response => response.data)
    .then((data) => {
      context.commit('setFeeProduct', data);
    })
  },
  getProducts(context) {
    axios.get(`${STORE_URL}/collections/${COLLECTION_HANDLE}.json`)
    .then(response => response.data)
    .then((data) => {
      // Figure out how many pages of data we have to pull
      const numOfPages = Math.ceil(data.collection.products_count / 250);
      fetchProducts(numOfPages, []);
    })
    .catch((err) => {
      console.log('***Error Fetching NumOfProducts***');
    });

    function fetchProducts(pageNum, productList) {
      // Recursive function that gets the full list of products
      if (pageNum != 0) {
        axios.get(`${STORE_URL}/collections/${COLLECTION_HANDLE}/products.json?limit=250&page=${pageNum}`)
          .then(response => response.data)
          .then((data) => {
            const updatedProductList = [...data.products, ...productList];
            fetchProducts(pageNum - 1, updatedProductList);
          })
          .catch((err) => {
            console.log('***Error Fetching Products***');
          });
      } else {
        sortFetchedProducts(productList);
      }
    }

    function sortFetchedProducts(totalProductList) {
      axios.get('https://api.happyboxstore.com/api/bundle/getGiftProducts')
      .then(response => response.data)
      .then((data) => {
        totalProductList =  totalProductList.map((item, i) => Object.assign({}, item, data.find(x => x.id == item.id)));
        const mainProductList = totalProductList.filter((product) => {
          if (product.product_type == MAIN_PRODUCT_TYPE && product.variants[0].inventory_quantity > 0) {
            product.maxCapacity = parseInt(product.variants[0].option1);
            product.variants = product.variants.map((variant) =>{
              variant.available = variant.inventory_quantity > 0;
              return variant
            })
            return product;
          }
        });
        var addonProductList = totalProductList.filter(product => product.product_type == ADDON_PRODUCT_TYPE);
        const cardProductList = totalProductList.filter(product => (product.product_type == CARD_PRODUCT_TYPE && product.variants[0].inventory_quantity > 0));
        context.commit('setMainProducts', mainProductList);
        context.commit('setAddonProducts', addonProductList);
        context.commit('setCardProducts', cardProductList);
        ga('send', {
          hitType: 'event',
          eventCategory: 'Multiship',
          eventAction: 'Navigation',
          eventLabel: `Start`
        });
      })
      .catch((err) => {
        console.log(err);
        console.log('***Error Fetching NumOfProducts***');
      });
    }
  }
};

export default actions;
